import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import {Link} from "react-router-dom";
import doc from "../../../../assets/doc/Instruction by change working schedule.docx"
import CreateScheduleChangeRequest from "./CreateScheduleChangeRequest";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import ScheduleChangeRequest from "./ScheduleChangeRequest";
import DrawAttribute from "@mnjsplatform/components/lib/common/GridView/DrawAttributeProvider";
import MnTooltipIcon from "../../../Common/MnTooltipIcon";
import i18next from "i18next";

class ScheduleChangeRequestList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showCreateRequest: false, showRequest: false, rowKey: null, confirmSendGetEmailChecked: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.initialize({}, {
                newItem: true,
                withParams: false,
                withStyle: true
            }));
        } catch (e) {
            console.error(e);
        }
    };

    callActionByKey = (action, rowKey, callbackFunc) => {
        if (!rowKey) {
            return;
        }

        switch (action) {
            case scheduleChangeRequestActions.send:
                this.sendRequest(rowKey, callbackFunc);
                break;
            case scheduleChangeRequestActions.return:
                this.returnRequest(rowKey, callbackFunc);
                break;
            case scheduleChangeRequestActions.getEmail:
                this.getRequestToEmail(rowKey);
                break;
            case scheduleChangeRequestActions.delete:
                this.deleteRequest(this.props.dataItem.getRowIndex(rowKey));
                break;
            default:
                break;
        }
    };

    deleteRequest = (rowIndex) => {
        confirm(i18next.t("ScheduleChangeRequestList_RequestDeletion_Text"), {header: i18next.t("ScheduleChangeRequestList_RequestDeletion_Title")})
            .then(async () => {
                this.hideRequest();
                await this.props.dispatch(this.props.dataItem.deleteRow(rowIndex));
            })
            .catch(() => {
            });
    };

    runCommand = async (rowKey, dataItem, dataItemParams) => {
        if (!dataItem.isInitialized) {
            await this.props.dispatch(dataItem.reset());
            await this.props.dispatch(dataItem.initialize(rowKey, {newItem: true, withParams: true}));
        } else {
            await this.props.dispatch(dataItemParams.setField(0, "VacancyCmdChTabCal", rowKey));
            await this.props.dispatch(dataItem.applyParams(dataItemParams));
        }
    };

    sendRequest = (rowKey, callbackFunc) => {
        confirm(<>
            <div>{i18next.t("ScheduleChangeRequestList_RequestSending_ConfirmText")}</div>
            <div>
                <input type="checkbox" className="checkbox"
                       onChange={(e) => {
                           this.setState({confirmSendGetEmailChecked: e.target.checked})
                       }}
                />
                &nbsp;{i18next.t("ScheduleChangeRequestList_RequestSending_ReceiveOrder_Checkbox")}
            </div>
        </>, {header: i18next.t("RequestSending")})
            .then(async () => {
                await this.runCommand(rowKey, this.props.actionItem_Send, this.props.actionItem_SendParams);
                if (this.state.confirmSendGetEmailChecked) {
                    await this.runCommand(rowKey, this.props.actionItem_GetEmail, this.props.actionItem_GetEmailParams);
                }
                if (callbackFunc) {
                    await callbackFunc();
                }
            })
            .catch(() => {
            });
    };

    returnRequest = (rowKey, callbackFunc) => {
        confirm(i18next.t("ScheduleChangeRequestList_RequestReturning_ConfirmText"), {header: i18next.t("RequestReturning")})
            .then(async () => {
                await this.runCommand(rowKey, this.props.actionItem_Return, this.props.actionItem_ReturnParams);
                if (callbackFunc) {
                    await callbackFunc();
                }
            })
            .catch(() => {
            });
    };

    getRequestToEmail = (rowKey) => {
        confirm(i18next.t("ScheduleChangeRequestList_OrderSending_ConfirmText"), {header: i18next.t("OrderSending")})
            .then(async () => {
                await this.runCommand(rowKey, this.props.actionItem_GetEmail, this.props.actionItem_GetEmailParams);
            })
            .catch(() => {
            });
    };

    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "RowActions") {
            return (<>
                    {cellParams.row.IsCreateCmdEnabled === 1 &&
                        <button className="btn" type="button" style={{color: "magenta"}}
                                title={i18next.t("ScheduleChangeRequest_SentToHR")}>
                            <i className="fa fa-send fa-lg" onClick={() => {
                                this.sendRequest(this.props.dataItem.getRowKey(cellParams.row))
                            }}/>&nbsp;
                        </button>}
                    {cellParams.row.IsUncreateCmdEnabled === 1 &&
                        <button className="btn" type="button" style={{color: "red"}}
                                title={i18next.t("ScheduleChangeRequest_ReturnFromHR")}>
                            <i className="fa fa-undo fa-lg" onClick={() => {
                                this.returnRequest(this.props.dataItem.getRowKey(cellParams.row))
                            }}/>&nbsp;
                        </button>}
                    {cellParams.row.IsSendCmdEnabled === 1 &&
                        <button className="btn" type="button" style={{color: "brown"}}
                                title={i18next.t("ScheduleChangeRequest_SendExcelToEmail")}>
                            <i className="fa fa-envelope-open fa-lg" onClick={() => {
                                this.getRequestToEmail(this.props.dataItem.getRowKey(cellParams.row))
                            }}/>&nbsp;
                        </button>}
                    {cellParams.row.IsDelCmdEnabled === 1 &&
                        <button className="btn" type="button" style={{color: "red"}}
                                title={i18next.t("ScheduleChangeRequest_DeleteRequest")}>
                            <i className="fa fa-trash-o fa-lg" onClick={() => {
                                this.deleteRequest(cellParams.rowIndex)
                            }}/>&nbsp;
                        </button>}
                </>);
        }

        if (cellParams.fieldInfo.Name === "sTypeStatus") {
            let tooltipText = DrawAttribute.cellTooltipProvider(cellParams.dataItem, cellParams.rowIndex, cellParams.fieldInfo);
            return (<>
                    {cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex)}
                    <MnTooltipIcon text={tooltipText} iconClass="fa fa-info-circle ml-2 gridcell-tooltip"/>
                </>);
        }

        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    };

    showCreateRequest = () => {
        return confirm(i18next.t("ScheduleChangeRequestList_RequestCreation_ConfirmText"), {header: i18next.t("RequestCreation")})
            .then(() => this.setState({showCreateRequest: true}))
            .catch(() => {
            });
    };

    hideCreateRequest = () => {
        this.setState({showCreateRequest: false})
    };

    onCellClick = (row, fieldInfo, e) => {
        if (fieldInfo.Name !== "RowActions") {
            let key = this.props.dataItem.getRowKey(row);
            this.showRequest(key);
        }
    };

    showRequest = (key) => {
        this.setState({rowKey: key, showRequest: true});
    };

    hideRequest = () => {
        this.setState({showRequest: false})
    };

    requestCreated = async (key) => {
        await this.props.dispatch(this.props.dataItem.refresh());
        this.showRequest(key);
    };

    render() {
        return (<>
{/*
                <PlaceholderWrapper placeholderId="10"
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    <Link to={doc} target="_blank"><><i
                        className='fa fa-info'/> {i18next.t("ScheduleChangeRequestList_InstructionTitle")}</>
                    </Link>
                </PlaceholderWrapper>
*/}

                <PlaceholderWrapper placeholderId="ScheduleChangeRequestList"
                                    title={<><i className='fa fa-table'/> {i18next.t("ScheduleChangeRequests")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    <button className="btn btn-regular -goahead" type="button" title={i18next.t("CreateRequest")}
                            onClick={this.showCreateRequest}>
                        <i className="fa fa-plus fa-lg"/>&nbsp;{i18next.t("CreateRequest")}
                    </button>
                    <div className="scheduleChangeRequest_gridContainer">
                        <GridView dataItem={this.props.dataItem}
                                  allowPagination={true}
                                  readOnly={true}
                                  useItemStyle={true}
                                  renderCellEx={this.renderCellEx}
                                  onCellClick={this.onCellClick}
                        />
                    </div>
                </PlaceholderWrapper>

                {this.state.showCreateRequest && <CreateScheduleChangeRequest onClose={this.hideCreateRequest}
                                                                              onCreated={this.requestCreated}
                />}

                {this.state.showRequest && <ScheduleChangeRequest onClose={this.hideRequest}
                                                                  rowKey={this.state.rowKey}
                                                                  callActionFunc={this.callActionByKey}
                />}
            </>);
    }
}

ScheduleChangeRequestList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    actionItem_Send: PropTypes.object,
    actionItem_SendParams: PropTypes.object,
    actionItem_Return: PropTypes.object,
    actionItem_ReturnParams: PropTypes.object,
    actionItem_GetEmail: PropTypes.object,
    actionItem_GetEmailParams: PropTypes.object

};

ScheduleChangeRequestList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.subScheduleChangeState.VacancyCmdChTabCal_PO_List,
        actionItem_Send: state.subScheduleChangeState.SubScheduleChangeRequest_Send,
        actionItem_SendParams: state.subScheduleChangeState.SubScheduleChangeRequest_SendParams,
        actionItem_Return: state.subScheduleChangeState.SubScheduleChangeRequest_Return,
        actionItem_ReturnParams: state.subScheduleChangeState.SubScheduleChangeRequest_ReturnParams,
        actionItem_GetEmail: state.subScheduleChangeState.SubScheduleChangeRequest_GetEmail,
        actionItem_GetEmailParams: state.subScheduleChangeState.SubScheduleChangeRequest_GetEmailParams
    }
}

export const scheduleChangeRequestActions = {
    send: "send", return: "return", getEmail: "getEmail", delete: "delete"
};

export default connect(mapStateToProps)(ScheduleChangeRequestList);